import React, { useState ,useEffect} from 'react'
import {  useParams } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import pencil from './iconos/pencil.svg'
import websal from './iconos/logowebsal.png'
import Swal from 'sweetalert2'
import { Loading } from './Loading';
import { baseUrlback } from '../../urlApi';
import {  MobileView,  } from 'react-device-detect';


export const HistorialSolicitudes = () => {

 
    
    const {id,codper} = useParams()

  

    const [objPdf, setobjPdf] = useState( {
        firmas: 0,
        link: "https://www.websal.com/docs/001/hwn1vpy4/7lj07ks12hss/1546-202205-cnw7xkwhlh.pdf",
        base64:'',
        maxFirmas:2,
        firmantes:[]
    })

  

    const [loadingDoc, setLoadingDoc] = useState(false)

 

    const consultarDatos = async () => {

        setLoadingDoc(true)

        try {

            
            const response = await axios.get(`${baseUrlback}api/firma/eliminadosById/${id}`);
      
              
             setobjPdf(response.data[0])
             setLoadingDoc(false)

             return response.data[0]


            } catch (error) {
             setLoadingDoc(false)
              
             console.log(error)
                
            }


    }

    useEffect(() => {

        consultarDatos()
    }, [])




    

//    console.log(data)

   const [loading, setloading] = useState(false)





  return (
    <div className='contenedorPdf'>

      {
        loadingDoc ? <Loading/> 
        :
        <>
                    {
                    objPdf.codper == codper ? 
                                <>
                                
                                <div>     
                                                            <div className='contenedorLogoFirma'>
                                                                    <img  className='websalFirma animate__animated animate__fadeIn' src={websal} alt='ver' />
                        
                                                            </div>
                        
                        
                        
                                                                <div className='contenedorFirmas'>
                        
                        
                        
                                                                <p className='ultimo tituloDocumento' >Documento: {objPdf.tipo} </p>
                        
                        
                        
                                                                
                                                                        
                                                                            <div className='documentos'>
                                                                                    <p className='nombre' > {objPdf.nombreTrabajador} </p>
                                                                                
                        
                                                                                <div className='contenedorPropiedadFirma' > 
                                                                                    <p>RUT</p>
                                                                                    <p> { objPdf.idTrabajador } </p>
                                                                                        
                                                                                </div>
                        
                                                                                <div className='contenedorPropiedadFirma' >
                        
                                                                                    <p>Fecha firma</p>
                                                                                    <p>{objPdf.fechaTrabajador ?objPdf.fechaTrabajador : '-' } </p>
                        
                                                                                </div>
                        
                                                                                <div className='contenedorPropiedadFirma' >
                                                                                
                                                                                    <p>IP</p>
                                                                                    <p> {objPdf.ipTrabajador ? objPdf.ipTrabajador : '-' } </p>
                        
                        
                                                                                </div>
                        
                                                                                <div className='contenedorPropiedadFirma last' >
                        
                                                                                    <p>Firmado desde</p>
                                                                                    <p className='ultimo' > {objPdf.soTrabajador ? objPdf.soTrabajador.toUpperCase() : '-'} </p>
                        
                                                                                </div>
                                                                                
                        
                                                                        </div>
                        
                                                                        {
                                                                        objPdf.idContraparte &&
                        
                                                                        <div className='documentos'>
                                                                                    <p className='nombre' > {objPdf.nombreContraparte} </p>
                                                                                
                        
                                                                                <div className='contenedorPropiedadFirma' > 
                                                                                    <p>RUT</p>
                                                                                    <p> { objPdf.idContraparte } </p>
                                                                                        
                                                                                </div>
                        
                                                                                <div className='contenedorPropiedadFirma' >
                        
                                                                                    <p>Fecha firma</p>
                                                                                    <p>{objPdf.fechaContraparte ?objPdf.fechaContraparte : '-' } </p>
                        
                                                                                </div>
                        
                                                                                <div className='contenedorPropiedadFirma' >
                                                                                
                                                                                    <p>IP</p>
                                                                                    <p> {objPdf.ipContraparte ? objPdf.ipContraparte : '-' } </p>
                        
                        
                                                                                </div>
                        
                                                                                <div className='contenedorPropiedadFirma last' >
                        
                                                                                    <p>Firmado desde</p>
                                                                                    <p className='ultimo' > {objPdf.soContraparte ? objPdf.soContraparte.toUpperCase() : '-'} </p>
                        
                                                                                </div>
                                                                                
                        
                                                                        </div>
                        
                        
                                                                        }

                                                                { objPdf.maxFirmas === 3 &&
                                                                                            
                                                                                            <div className='documentos'>
                                                                                            
                                                                                                <p className='nombre' > {objPdf.nombreContraparte2} </p>
                                                                                        

                                                                                                <div className='contenedorPropiedadFirma' > 
                                                                                                    <p>RUT</p>
                                                                                                    <p> {objPdf.idContraparte2} </p>
                                                                                                        
                                                                                                </div>

                                                                                                <div className='contenedorPropiedadFirma' >

                                                                                                    <p>Fecha firma</p>
                                                                                                    <p>{objPdf.fechaContraparte2 ? objPdf.fechaContraparte2 : '-' } </p>

                                                                                                </div>

                                                                                                <div className='contenedorPropiedadFirma' >
                                                                                                
                                                                                                    <p>IP</p>
                                                                                                    <p> {objPdf.ipContraparte2 ? objPdf.ipContraparte2 : '-' } </p>


                                                                                                </div>

                                                                                                <div className='contenedorPropiedadFirma last' >

                                                                                                    <p>Firmado desde</p>
                                                                                                    <p className='ultimo' > {objPdf.soContraparte2 ? objPdf.soContraparte2.toUpperCase() : '-'} </p>

                                                                                                </div>
                                                                                                

                                                                                        </div>
                                                                                            
                                                                                            
                                                                                            }
                        
                                                                        
                        
                                                                            
                        
                                                                            
                        
                                                                <p className='tituloDocumento'> Firmas: {objPdf.firmas} </p>
                        
                        
                                                                        {
                                                                            loading && <Loading/>
                                                    
                                                                        }
                        
                        
                                                                        
                        
                        
                                                                </div>
                        
                        
                        
                                                    </div>
                        
                                                
                        
                        
                                                <div className='pdf' >
                        
                        
                                                    {
                                                        objPdf.link &&
                        
                                                        <object
                                                
                                                        data={`https://websalsign.s3.amazonaws.com/${objPdf.link}`}
                                                        type="application/pdf" width="100%" height="100%"></object>
                                                    }
                        
                                        <MobileView>
                                            <div className='contenedorDescargarTelefono'>
                                            <a href={`https://websalsign.s3.amazonaws.com/${objPdf.link}`} className="descargarTelefono" download target="_blank">Descargar</a>

                                            </div>
                        
                                        </MobileView>
                                                                        
                                                  
                        
                                                        
                        
                                                        
                                                </div>
                                
                                
                                
                                
                                
                                </>
                        
                                :
                            
                                <p className='errorMsg' >Error: No existe este documento</p>
                        
                    }
        </>
    }
      
    
                       



      
        
       
     </div>
  )
}
